import { ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

export const infoButton: ThemeUICSSObject = {
  '&.iconButton': {
    cursor: 'pointer',
    height: '0px',
    minHeight: '16px',
    color: 'palette.gray.800',
    p: spacing(0),
    width: 'auto',
    minWidth: 'auto',
    svg: {
      height: '15px',
      width: '15px',
    },

    '&.isToggled': {
      cursor: 'pointer',
      minHeight: '0px',
      color: 'palette.primary.main',
    },
  },
};
